import React from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  animated?: boolean;
}

export const AppLogo: React.FC<AppLogoProps> = ({
  size = 32,
  className = '',
  showText = false,
  animated = false
}) => {
  return (
    <div className={`flex items-center gap-2.5 select-none ${className}`}>
      <div 
        style={{ width: size, height: size }}
        className="relative shrink-0 flex items-center justify-center group"
      >
        <svg
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`w-full h-full drop-shadow-md ${animated ? 'hover:scale-105 transition-transform duration-300' : ''}`}
        >
          <defs>
            <linearGradient id="brand-vdp-bg" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#1c2885"/>
              <stop offset="100%" stopColor="#111c64"/>
            </linearGradient>
            <clipPath id="squircle-logo-clip">
              <rect x="0" y="0" width="512" height="512" rx="112" ry="112"/>
            </clipPath>
          </defs>
          
          <rect x="0" y="0" width="512" height="512" rx="112" ry="112" fill="url(#brand-vdp-bg)"/>
          
          <g clipPath="url(#squircle-logo-clip)">
            {/* White V Lettermark */}
            <path d="M 96 150 L 192 150 L 256 368 L 320 150 L 416 150 L 288 448 L 224 448 Z" fill="#ffffff"/>
            
            {/* 3 Teal Data Blocks */}
            <rect x="330" y="150" width="88" height="42" rx="10" fill="#00cca8"/>
            <rect x="330" y="216" width="88" height="42" rx="10" fill="#00cca8"/>
            <rect x="300" y="282" width="118" height="42" rx="10" fill="#00cca8"/>
            
            {/* Peeled Sticker Flap */}
            <path d="M 512 300 C 420 310 300 420 310 512 L 512 512 Z" fill="#00cca8"/>
            <path d="M 512 300 C 420 310 300 420 310 512" fill="none" stroke="#ffffff" strokeWidth="14" strokeLinecap="round"/>
          </g>
        </svg>
      </div>

      {showText && (
        <div className="flex flex-col min-w-0">
          <span className="font-black text-sm tracking-tight text-white truncate leading-tight">
            Variable Sticker
          </span>
          <span className="text-[10px] font-extrabold text-[#00cca8] tracking-widest uppercase truncate leading-tight">
            VDP STUDIO
          </span>
        </div>
      )}
    </div>
  );
};
